
<h2 mat-dialog-title i18n="@@confirm-dialog-title">Please confirm</h2>
<mat-dialog-content>
    <div *ngIf="data && data.control === 'channelTermsetGUID'">
        <p>
          <span class="bolder mr-1" i18n="@@help-warning-text">Warning!</span>
          <span i18n="@@information-message-channelTermsetGUID-line-one">Changing this setting can cause major issues to all Workplace features using channels.</span>
        </p>
        <ul>
          <li i18n="@@information-message-channelTermsetGUID-point-one">
            Users can lose existing personalized settings from the settings page
          </li>
          <li i18n="@@information-message-channelTermsetGUID-point-two">
            Users can stop receiving personalised content from Workplace and SharePoint
          </li>
        </ul>
        <p class="bolder mr-1" i18n="@@help-consideration-text">Some considerations before making the change:</p>
        <ul>
          <li i18n="@@information-message-channelTermsetGUID-consideration-point-one">
            The purpose of this setting is mainly to allow running multiple instances of Workplace with separate channel configurations in the same environment. It is a good idea to change this for a test installation for example
          </li>
          <li i18n="@@information-message-channelTermsetGUID-consideration-point-two">
            This setting should best be changed before users log on to the system and before creating any content tagged with channel
          </li>
          <li i18n="@@information-message-channelTermsetGUID-consideration-point-three">
            Since channel selections are cached for 24 hours this change should preferably be done over the weekend if done in a live environment
          </li>
          <li i18n="@@information-message-channelTermsetGUID-consideration-point-four">
            Do not change this setting without consulting with you supplier contact
          </li>
          <li i18n="@@information-message-channelTermsetGUID-consideration-point-five">
            The channel column used in SharePoint must be updated to use the new term set, or the channel terms will not match
          </li>
        </ul>
        <p>
          <span class="bolder mr-1" i18n="@@feature-settings-help-note-text">Note:</span>
          <span i18n="@@information-message-channelTermsetGUID-note">Changing this setting after the application has already been used requires some additional changes and cleanup.</span>
        </p>
        <ul>
          <li i18n="@@information-message-channelTermsetGUID-note-point-one">
            News from SharePoint tagged with channels must be re-tagged with the new channel terms
          </li>
          <li i18n="@@information-message-channelTermsetGUID-note-point-two">
            Content in the Workplace database must have their old channels removed or updated with the new channel term references
          </li>
        </ul>
    </div>
    <p i18n="@@confirm-dialog-content">Are you sure you want to perform this action?</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="warn" class="mr-3 primary-contrast-color" (click)="confirm()">OK</button>
    <button mat-button mat-flat-button class="subtle-button-color" mat-dialog-close i18n="@@confirm-dialog-cancel">Cancel</button>
</mat-dialog-actions>

